__turbopack_context__.v({
  "animate": "_8Nvjbq_animate",
  "pressScroll": "_8Nvjbq_pressScroll",
  "root": "_8Nvjbq_root",
});
